export const MSG_CHAMP_OBLIGATOIRE =<>Ce champ est obligatoire&#8239;!</>;
export const MSG_EMAIl_VALIDATION =<>Veuillez entrer une adresse email valide&#8239;!</>;
export const MSG_TEL_VALIDATION =<>Veuillez entrer un téléphone valide&#8239;!</>;
export const MSG_LONGITUDE_VALIDATION =<>Veuillez entrer de Longitude valide&#8239;!</>;
export const MSG_LATITUDE_VALIDATION =<>Veuillez entrer de Latitude valide&#8239;!</>;
export const MSG_NOMBRE_VALIDATION =<>Veuillez entrer un nombre positif&#8239;!</>;
export const MSG_TARIF_VALIDATION =<>Veuillez entrer un tarif valide&#8239;!</>
export const MSG_ERREUR_SAUVEGARDE ="Une erreur est survenue lors de la sauvegarde des données !";
export const MSG_DATA_SAVED ="Données sauvegardées !";
export const MSG_UPDATE_SUCCESS ="Modification effectuée avec succès !";
export const MSG_DATA_DELETED="Données supprimées !";
export const MSG_ERREUR_DELETE="Une erreur est survenue lors de la suppression des données !";
export const MSG_NB_LIT_REQUIRED="Veuillez renseigner au moins un nombre de lit parmis les types proposés dans l'onglet \"Lit\" !";
export const MSG_ERREUR_SERVEUR = "Une erreur est survenue lors du chargement de cette page. Veuillez réessayer ultérieurement."
export const MSG_ERREUR_MAX_ONE_FIELD_REQUIRED = "Veuillez renseigner au moins un champs."
export const MSG_ERREUR="Une erreur est survenue !";
export const MSG_PASSWORD_SAVED="Mot de passe enregistré. Vous pouvez maintenant vous connecter.";
export const MSG_CHANGE_PASSWORD="Changement de mot de passe";
